import React from 'react';
import styled from '@emotion/styled';
import { appStyles } from '../../../../styles';
import { UploadImage } from '../../../../assets';

export interface AttributeValues {
  backgroundImage?: string;
  textColor?: string;
  title?: string;
  subTitle?: string;
  ctaText?: string;
  describeText?: string;
  describeText2?: string;
}
interface PreviewProps {
  values: AttributeValues & any;
  isPreview?: boolean;
  className?: string;
}

export const PreviewMainstays = (props: PreviewProps) => {
  const { values, isPreview, className } = props;
  const { backgroundImage, title, describeText, describeText2, background, titleColor, subTitle, subColor } = values;
  const isDefaultImage = backgroundImage === '' || !backgroundImage || !isPreview;

  const parseString = (str: string) => {
    const num: number = str.length;
    if (num > 50) {
      const newStr: string = str.substring(0, 50);
      return `${newStr}...`;
    }
    return str;
  };

  const parseSubTitle = (str: string) => {
    const num: number = str.length;
    if (num > 87) {
      const newStr: string = str.substring(0, 87);
      return `${newStr}...`;
    }
    return str;
  };

  return (
    <StyledMainstaysPreview className={className} style={{ height: '100px', backgroundColor: background || '#fff' }}>
      <div>
        <div className={!isDefaultImage ? 'preview-ant-image' : 'preview-ant-image image-border'}>
          <StyledLinearGradient />
          {!isDefaultImage ? (
            <img className="image-mainstays" src={backgroundImage} alt="" />
          ) : (
            <div className="image-default">
              <img src={UploadImage} alt="" />
              <div className="describeText">{describeText}</div>
              <div className="describeText2">{describeText2}</div>
            </div>
          )}
          <div className="right-panel">
            {title && (
              <div className="heading" style={{ color: titleColor || '#000' }}>
                {parseString(title)}
              </div>
            )}
            {subTitle && (
              <div className="sub-title" style={{ color: subColor || '#000' }}>
                {parseSubTitle(subTitle)}
              </div>
            )}
          </div>
        </div>
      </div>
    </StyledMainstaysPreview>
  );
};

const StyledLinearGradient = styled.div`
  ${appStyles.fullWidthHeight}
  ${appStyles.borderRadiusPreview}
  position: absolute;
`;

const StyledMainstaysPreview = styled.div`
  margin: 2rem 1.5rem;
  min-height: 139px;
  position: relative;
  text-align: left;
  line-height: 1.2;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  & .right-panel {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
  }
  & .heading {
    font-weight: 700;
    font-size: 17px;
    padding: 0 1rem;
  }
  & .sub-title {
    font-size: 15px;
    padding: 0.5rem 1rem;
  }
  & .image-border {
    border-bottom: 1px #c3c3c3 solid;
  }
  & .preview-ant-image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 0;
    height: 139px;
    padding: 4px;
    border-radius: 16px;
    & .image-mainstays {
      width: 131px;
      height: 131px;
      object-fit: cover;
      padding: 0;
      border-radius: 12px;
    }
    & .image-default {
      justify-content: center;
      text-align: center;
      min-width: 131px;
      min-height: 131px;
      border: 1px #000 solid;
      border-radius: 12px;
      & img {
        margin-top: 1rem;
        width: 3.5rem;
        height: 3.5rem;
      }
      & .describeText {
        font-size: 10px;
        padding-top: 1rem;
        font-weight: 600;
      }
      & .describeText2 {
        font-size: 9px;
        padding-top: 0.5rem;
        font-weight: 600;
      }
    }
  }
  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logo-brand {
    margin: 0.7rem 1rem;
    & .logo-tm {
      width: 2.5rem;
      padding-right: 10px;
      height: auto;
    }
    & .img-partner {
      padding-left: 10px;
      width: auto;
      max-height: 3rem;
    }
  }
  .uploadText {
    position: absolute;
    width: 100%;
    text-align: center;
    margin-top: 4rem;
    color: white;
  }
  .textContainer {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .wrapper-text-preview {
    position: absolute;
    bottom: 20%;
    width: 100%;
    padding: 0 1rem;
  }
  & .title {
    font-size: 25px;
  }
  & .priceColor {
    display: block;
    font-size: 11px;
  }
  .promotion-preview {
    & .description {
      font-size: 25px;
    }
    & .title {
      font-size: 14px;
    }
  }
  & .wrapper-btn-preview {
    position: absolute;
    bottom: 8px;
    width: 100%;
    display: flex;
    padding: 0 1rem;
    & .button {
      border-radius: 1rem;
      background: #fff;
      color: #000;
      height: 30px;
      font-size: 16px;
      padding: 0.2rem 1.25rem 0 1.25rem;
    }
  }

  @media screen and (max-width: 1440px) {
    .text-preview {
      bottom: 13%;
    }
    & .description {
      font-size: 12px;
    }
    & .title {
      font-size: 21px;
    }

    .promotion-preview {
      & .description {
        font-size: 21px;
      }
      & .title {
        font-size: 15px;
      }
    }
  }
`;
